import { render, staticRenderFns } from "./Tote.vue?vue&type=template&id=5fc28810"
import script from "./Tote.vue?vue&type=script&lang=js"
export * from "./Tote.vue?vue&type=script&lang=js"
import style0 from "./Tote.vue?vue&type=style&index=0&id=5fc28810&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports